import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '../../@core/layout/layout.module';
import { MainLayoutComponent } from './main-layout.component';
import { SidenavModule } from '../../@core/layout/sidenav/sidenav.module';
import { ToolbarModule } from '../../@core/layout/toolbar/toolbar.module';
import { FooterModule } from '../../@core/components/footer/footer.module';
import { ConfigPanelModule } from '../../@core/components/config-panel/config-panel.module';
import { SidebarModule } from '../../@core/components/sidebar/sidebar.module';
import { QuickpanelModule } from '../../@core/components/quickpanel/quickpanel.module';
import { SharedModule } from '../shared/shared.module';
import { AryaChatModule } from '../../@core/components/arya-chat/arya-chat.module';


@NgModule({
  declarations: [MainLayoutComponent],
  imports: [
    CommonModule,
    LayoutModule,
    SidenavModule,
    ToolbarModule,
    FooterModule,
    ConfigPanelModule,
    SidebarModule,
    QuickpanelModule,
    SharedModule,
    AryaChatModule,

  ]
})
export class MainLayoutModule {
}
